export enum TimelineItemStatus {
  DONE = "DONE",
  IN_PROCESS = "IN_PROCESS",
  PENDING = "PENDING",
}
